import { render, staticRenderFns } from "./carDispatch.vue?vue&type=template&id=15ae5610&scoped=true"
import script from "./carDispatch.vue?vue&type=script&lang=js"
export * from "./carDispatch.vue?vue&type=script&lang=js"
import style0 from "./carDispatch.vue?vue&type=style&index=0&id=15ae5610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ae5610",
  null
  
)

export default component.exports